import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';

const StrokeTitle = ({text}) => {

  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true
  });

  const [stroke, setStroke] = useState(false);


  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setStroke(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/bg.webp`;
  }, []);

  return (
    <div className={`stroke-title ${inView && stroke && "stroke-visible"}`} ref={ref}>
      <h2 className="gradient-text">{text}</h2>
      <span></span>
    </div>
  )
}

export default StrokeTitle;